import { useQueryClient } from '@tanstack/react-query'
import { Icon } from '@/common/components/icon'
import { useMockTime } from '@/common/hooks/useMockTime'
import * as styles from './MockTimeBanner.css'

export function MockTimeBanner() {
  const { enabled, override, setOverride, clearOverride } = useMockTime()
  const queryClient = useQueryClient()

  if (!enabled) return null

  const variant = override ? 'active' : 'inactive'

  function handleDateChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value) {
      setOverride(e.target.value)
      queryClient.invalidateQueries()
    }
  }

  function handleReset() {
    clearOverride()
    queryClient.invalidateQueries()
  }

  if (!override) {
    return (
      <div className={styles.banner[variant]} role="status">
        <div className={styles.icon}>
          <Icon name="schedule" size={18} />
        </div>
        <span className={styles.label}>Mock Time</span>
        <span className={styles.dateDisplay}>Using real time</span>
        <div className={styles.spacer} />
        <input
          type="date"
          className={styles.dateInput[variant]}
          value=""
          onChange={handleDateChange}
          aria-label="Set mock date"
        />
      </div>
    )
  }

  const formatted = new Date(override + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })

  return (
    <div className={styles.banner[variant]} role="status">
      <div className={styles.icon}>
        <Icon name="schedule" size={18} />
      </div>
      <span className={styles.label}>Mock Time</span>
      <span className={styles.dateDisplay}>{formatted}</span>
      <div className={styles.spacer} />
      <input
        type="date"
        className={styles.dateInput[variant]}
        value={override}
        onChange={handleDateChange}
        aria-label="Set mock date"
      />
      <button
        type="button"
        className={styles.resetButton}
        onClick={handleReset}
      >
        Reset
      </button>
    </div>
  )
}
